module.exports = __webpack_public_path__ + "r-v3/img/btn-debate_share.37ed6749.svg";